import React from "react";

const Layout = ({ children }) => (
  <div id="layout-wrapper">
    <div className="main-content">{children}</div>
  </div>
);

export default Layout;
